import React, { useState, forwardRef } from "react";
import { DataGrid } from '@mui/x-data-grid';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";

import Loader from "components/Loader/Loader";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

moment.locale("es");

export default function ReporteDiario() {
  
  const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    cardTitle: {
      marginTop: "0",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    select: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset",
      "&:before": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      },
      "&:after": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      }
    },
    container: {
      textAlign: "center"
    },
    content: {
      display: "inline-flex",
      padding: "10px",
      alignItems: "center"
    },
    paddingBottomCard: {
      paddingBottom: "40px"
    },
    marginRight: {
      marginRight: "10px"
    },
    marginBottom: {
      marginBottom: "50px"
    },
    formControl: {
      marginTop: theme.spacing(3.5),
      minWidth: "100%"
    },
    formControl2: {
      minWidth: "100%",
      marginTop: theme.spacing(5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }));

  const classes = useStyles();

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [load, setLoad] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [columnReporte] = useState([
    { title: "Folio", field: "Folio", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Nombre", field: "Nombre", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Cuenta", field: "Cuenta", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "ProductoUP", field: "ProductoUP", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Correo", field: "Correo", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Celular", field: "Celular", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Telefono Fijo", field: "TelefonoFijo", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Telefono Trabajo", field: "TelefonoTrabajo", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Fecha Captura", field: "FechaCaptura", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Costo", field: "Costo", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Flag Actividad", field: "FlagActividad", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Banco Emisor", field: "BancoEmisor", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Condicion TDC Adicional", field: "CondicionTDCAdicional", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Seg Revolvencia", field: "SegRevolvencia", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Saldo", field: "Saldo", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Propension", field: "Propension", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Antiguedad", field: "Antiguedad", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Limite Credito", field: "LimiteCredito", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Incremento", field: "Incremento", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Adicional ", field: "Adicional", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Comentario", field: "Comentario", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "MSI", field: "MSI", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Agendado", field: "Agendado", type: "string", headerClassName: 'super-app-theme--header', width: 200 },
    { title: "Tipo Base", field: "TipoBase", type: "string", headerClassName: 'super-app-theme--header', width: 300 },
    { title: "Fecha Sanitizacion", field: "FechaSanitizacion", type: "string", headerClassName: 'super-app-theme--header', width: 300 },
    { title: "Fecha Capturista", field: "FechaCapturista", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Nombre Capturista", field: "NombreCapturista", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Estatus", field: "Estatus", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Token", field: "Token", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Respuesta Mensaje", field: "RespuestaMensaje", type: "string", headerClassName: 'super-app-theme--header', width: 100 },
    { title: "Estatus General", field: "EstatusGeneral", type: "string", headerClassName: 'super-app-theme--header', width: 100 }
  ]);
  const [reporte, setReporte] = useState([]);

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const convertToCSV = (objArray) => {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
        let line = "";

        for (let index in array[i]) {
            if (line !== "") line += ",";
            line += array[i][index];
        }

        str += line + "\r\n";
    }

    return str;
  };

  const exportCSVFile = (headers, items, fileName) => {
    if (headers) {
        items.unshift(headers);
    }

    const jsonObject = JSON.stringify(items);
    const csv = convertToCSV(jsonObject);
    const exportName = fileName + ".csv" || "export.csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
    } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  };

  const exportData = (JSONData) => {
    let arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
    let reportTitle = "Reporte_General";
    let headers = {};

    arrData = arrData.map(item => { 
      return { 
        Folio: item.Folio.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""), 
        Nombre: item.Nombre.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Cuenta: "'" + item.Cuenta,
        ProductoUP: item.ProductoUP.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Correo: item.Correo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Celular: item.Celular.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        TelefonoFijo: item.TelefonoFijo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        TelefonoTrabajo: item.TelefonoTrabajo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        FechaCaptura: item.FechaCaptura.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Costo: item.Costo,
        FlagActividad: item.FlagActividad.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        BancoEmisor: item.BancoEmisor.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        CondicionTDCAdicional: item.CondicionTDCAdicional.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        SegRevolvencia: item.SegRevolvencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Saldo: "'" + item.Saldo,
        Propension: item.Propension.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Antiguedad: "'" + item.Antiguedad,
        LimiteCredito: "'" + item.LimiteCredito,
        Incremento: "'" + item.Incremento,
        Adicional: item.Adicional.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Comentario: item.Comentario.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        MSI: item.MSI.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Agendado: item.Agendado.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        TipoBase: item.TipoBase.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        FechaSanitizacion: item.FechaSanitizacion.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        FechaCapturista: item.FechaCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        NombreCapturista: item.NombreCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Estatus: item.Estatus.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Token: "'" + item.Token, 
        RespuestaMensaje: item.RespuestaMensaje.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        EstatusGeneral: item.EstatusGeneral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
      };
    });

    headers = {
        Folio: "Folio",
        Nombre: "Nombre",
        Cuenta: "Cuenta",
        ProductoUP: "ProductoUP",
        Correo: "Correo",
        Celular: "Celular",
        TelefonoFijo: "Telefono Fijo",
        TelefonoTrabajo: "Telefono Trabajo",
        FechaCaptura: "Fecha Captura",
        Costo: "Costo",
        FlagActividad: "Flag Actividad",
        BancoEmisor: "Banco Emisor",
        CondicionTDCAdicional: "Condicion TDC Adicional",
        SegRevolvencia: "Seg Revolvencia",
        Saldo: "Saldo",
        Propension: "Propension",
        Antiguedad: "Antiguedad",
        LimiteCredito: "Limite Credito",
        Incremento: "Incremento",
        Adicional: "Adicional",
        Comentario: "Comentario",
        MSI: "MSI",
        Agendado: "Agendado",
        TipoBase: "Tipo Base",
        FechaSanitizacion: "Fecha Sanitizacion",
        FechaCapturista: "Fecha Capturista",
        NombreCapturista: "Nombre Capturista",
        Estatus: "Estatus",
        Token: "Token",
        RespuestaMensaje: "RespuestaMensaje",
        EstatusGeneral: "EstatusGeneral",
    };
    
    exportCSVFile(headers, arrData, reportTitle);
  };

  const GetIdSucursal = () => {
    return JSON.parse(localStorage.getItem('userPortafolios')).IdSucursales;
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
            if (result !== undefined) {
                let body = {
                    FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
                    FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
                    IdSucursales: GetIdSucursal()
                };

                ReporteDiario(body, result.token)
                .then(result => {
                      let capturas = result.capturas.map((element) => {
                        element.FechaCaptura = element.FechaCaptura === "" ? "" : moment(moment(element.FechaCaptura, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");
                        element.FechaSanitizacion = element.FechaSanitizacion === "" ? "" : moment(moment(element.FechaSanitizacion, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");
                        element.FechaCapturista = element.FechaCapturista === "" ? "" : moment(moment(element.FechaCapturista, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");
                        element.Adicional = element.Adicional === "1" ? "Si" : "No";
                        element.Agendado = element.Agendado === "1" ? "Si" : "No";
                        element.id = element.Folio;

                        return element;
                      });
                    setReporte(capturas);
                    setLoad(false);
                });
            } else {
                sendSnackBar("Error de conexión", "error");
                setLoad(false);
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const ReporteDiario = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/ReporteDiario",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Login = async () => {
      let dataResponse;
      try {
          let header = {
              method: "POST",
              body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
              headers: {
                  "Content-Type": "application/json"
              }
          };

          let response = await fetch(
              process.env.REACT_APP_URL_APICORE + "Login",
              header
          );

          dataResponse = await response.json();
      } catch (error) {
          sendSnackBar("Error de conexión", "error");
      }

      return dataResponse;
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="yyyy/MM/dd"
                    label="Fecha inicio"
                    value={selectFechaInicio}
                    onChange={(date) => setSelectedFechaInicio(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Fecha Final"
                    format="yyyy/MM/dd"
                    value={selectFechaFin}
                    onChange={(date) => setSelectedFechaFin(date)}
                    slotProps={{ textField: { fullWidth: true } }}
                    renderInput={(props) => <TextField {...props} />}
                  />
                </DemoContainer>
              </FormControl>
            </GridItem>
          </Grid>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  exportData(reporte);
                }}
                color="info"
              >
                Descargar reporte
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
      <DataGrid
        rows={reporte}
        columns={columnReporte}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        autoHeight
        sx={{
          boxShadow: 2,
          border: 2,
          borderColor: 'primary.light',
          '& .MuiDataGrid-cell:hover': {
            color: 'primary.main',
          },
          '& .super-app-theme--header': {
            backgroundColor: 'primary.light',
          },
        }}
      />
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        <Loader load={load} />
    </div>
  );
}